import React from 'react';
import styles from './WinnerCard.module.css';
import firstPosition from '../../assets/firstPosition.png';
import secondPosition from '../../assets/secondPosition.png';
import thirdPosition from '../../assets/thirdPosition.png';
import API_CONFIG from '../../config/api';

const WinnerCard = ({ winner }) => {
  // Sort students by rank: 2nd, 1st, 3rd (left, center, right)
  const sortedStudents = winner.studentsData
    ?.filter(s => ['1', '2', '3'].includes(String(s.rank).charAt(0)))
    ?.sort((a, b) => {
      const rankOrder = { '2': 0, '1': 1, '3': 2 };
      return rankOrder[String(a.rank).charAt(0)] - rankOrder[String(b.rank).charAt(0)];
    });

  // Function to get position image based on rank
  const getPositionImage = (rank) => {
    const rankNumber = String(rank).charAt(0);
    switch (rankNumber) {
      case '1':
        return firstPosition;
      case '2':
        return secondPosition;
      case '3':
        return thirdPosition;
      default:
        return firstPosition;
    }
  };

  const getStudentImage = (student) => {
    if (!student.image) return null;

    // If it's a full path starting with public/, remove it as IMAGES_URL already includes /public
    let cleanPath = student.image;
    if (cleanPath.startsWith('public/')) {
      cleanPath = cleanPath.replace('public/', '');
    }

    // If the cleaned path still has slashes, it's a relative path from public/
    if (cleanPath.includes('/')) {
      return `${API_CONFIG.IMAGES_URL}/${cleanPath}`;
    }

    // Default to legacy dynamic photo path if it's just a filename
    return `${API_CONFIG.IMAGES_URL}/Polymatch/Polymatch-Photos/${cleanPath}`;
  };

  return (
    <div className={styles.winnerCardContainer}>
      <div className={styles.winnerCard}>
        <div className={styles.studentsRow}>
          {sortedStudents?.map((student, studentIndex) => (
            <div
              className={`${styles.studentCard} ${String(student.rank).charAt(0) === '1' ? styles.firstPlace : ''}`}
              key={studentIndex}
            >
              <div className={styles.studentImageContainer}>
                {student.image ? (
                  <img
                    src={getStudentImage(student)}
                    alt={student.name}
                    className={styles.studentImage}
                  />
                ) : (
                  <div className={styles.studentImagePlaceholder}>
                    {student.name ? student.name.charAt(0) : '?'}
                  </div>
                )}
              </div>
              <div className={styles.positionImageContainer}>
                <img
                  src={getPositionImage(student.rank)}
                  alt={`${student.rank} Position`}
                  className={styles.positionImage}
                />
              </div>
              <div className={styles.studentInfo}>
                <h4 className={styles.studentName}>{student.name}</h4>
                <p className={styles.studentAge}>{student.age}</p>
                <div className={styles.studentLocation}>
                  {student.city ? `${student.city}, ${student.country}` : student.country}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <h3 className={styles.winnerAgeCategory}>{winner.ageCategory}</h3>
    </div>
  );
};

export default WinnerCard;
